/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  workbench.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:31
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

const homesRouter = [
  {
    path: "/homes",
    name: "Homes",
    component: () =>
        import(/* webpackChunkName: "login" */ "@/views/homes/index.vue"),
    meta: {
      title: "首页",
      keepAlive: true,
      permission: true,
      deepth: 1
    },
  },
  {
    path: "/searchHomes",
    name: "SearchHomes",
    component: () =>
            import(/* webpackChunkName: "login" */ "@/views/homes/searchHomes.vue"),
    meta: {
      title: "搜索",
      keepAlive: true,
      deepth: 2
    },
  },
  {
    path: "/applicationList",
    name: "ApplicationList",
    component: () =>
            import(/* webpackChunkName: "login" */ "@/views/homes/applicationList.vue"),
    meta: {
      title: "全部应用",
      permission: true,
      deepth: 1
    },
  },
]

export default homesRouter
